export const getCCWeeklyReportTableRows = (data) => {
	const rows = data.map((d, i) => (
		<tr key={i}>
			<td>{d['dateFrom']}</td>
			<td>{d['dateTo']}</td>
			<td>{d['confirmed']}</td>
			<td>{d['resignedAfter']}</td>
			<td>{d['resignedAfterPercent']}%</td>
			<td>{d['sentImmediately']}</td>
			<td>{d['sentAnytime']}</td>
			<td>{d['toSend']}</td>
			<td>{d['delivered']}</td>
			<td>{d['deliveredPercent']}%</td>
			<td>{d['onlinePayment']}</td>
			<td>{d['paid']}</td>
			<td>{d['leads']}</td>
		</tr>
	));

	return rows;
};
